<script lang="ts">

/**
 * VDataGridGroupV2 — декларативный компонент для заголовка группы
 *
 * Контент внутри компонента становится шаблоном заголовка группы.
 * Доступные переменные: parent, children
 *
 * @example
 * <VDataGridGroupV2>
 *   {{ parent.number }} — {{ parent.seller.name }} ({{ children.length }} позиций)
 * </VDataGridGroupV2>
 */
export default defineComponent({
  name: 'VDataGridGroupV2',

  props: {
    parent: Object,
    children: Array<Object>,
    isDisabled: {
      type: Boolean,
      default: false
    }
  },

  render() {
    return null;
  },
});
</script>
